var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_93",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34.3572,
    height: 34.3572,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.884 30.0626C10.4981 30.0626 8.47003 29.2275 6.79989 27.5574C5.12975 25.8872 4.29468 23.8592 4.29468 21.4733V12.884C4.29468 10.4981 5.12975 8.47003 6.79989 6.79989C8.47003 5.12975 10.4981 4.29468 12.884 4.29468H21.4733C23.8592 4.29468 25.8872 5.12975 27.5574 6.79989C29.2275 8.47003 30.0626 10.4981 30.0626 12.884V21.4733C30.0626 23.8592 29.2275 25.8872 27.5574 27.5574C25.8872 29.2275 23.8592 30.0626 21.4733 30.0626H12.884ZM15.7471 22.9048L24.3364 14.3155L22.3322 12.3114L15.7471 18.8965L12.5977 15.7471L10.5935 17.7512L15.7471 22.9048ZM12.884 27.1995H21.4733C23.048 27.1995 24.396 26.6388 25.5174 25.5174C26.6388 24.396 27.1995 23.048 27.1995 21.4733V12.884C27.1995 11.3093 26.6388 9.96123 25.5174 8.83985C24.396 7.71847 23.048 7.15778 21.4733 7.15778H12.884C11.3093 7.15778 9.96123 7.71847 8.83985 8.83985C7.71847 9.96123 7.15778 11.3093 7.15778 12.884V21.4733C7.15778 23.048 7.71847 24.396 8.83985 25.5174C9.96123 26.6388 11.3093 27.1995 12.884 27.1995Z",
    fill: "#3184C9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickmark);
export default __webpack_public_path__ + "static/media/tickmark.8b44719f39064cb6029a5162fed99337.svg";
export { ForwardRef as ReactComponent };